/**
 *  Google ремаркетинг через тег
 */
export class GoogleRemarketingTag {

    indexPageView() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'google_tag_params': {
                'ecomm_pagetype': 'home',
            },
        });
    }

    categoryPageView(products) {
        let ids = [];
        products.forEach(product => {
            ids.push(product.id);
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'google_tag_params': {
                'ecomm_prodid': ids,
                'ecomm_pagetype': 'category',
            },
        });
    }

    productPageView(product) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'google_tag_params': {
                'ecomm_prodid': product.id,
                'ecomm_pagetype': 'product',
                'ecomm_totalvalue': parseFloat(product.price),
            },
        });
    }

    searchPageView(products) {
        let ids = [];
        products.forEach(product => {
            ids.push(product.id);
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'google_tag_params': {
                'ecomm_prodid': ids,
                'ecomm_pagetype': 'searchresults',
            },
        });
    }

    basketPageView(basket) {

        let ids = [], prices = 0;
        basket.forEach(product => {
            ids.push(product.id);
            prices += product.price;
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'google_tag_params': {
                'ecomm_prodid': ids,
                'ecomm_pagetype': 'cart',
                'ecomm_totalvalue': parseFloat(prices),
            },
        });
    }

    orderCreated(basket) {
        let ids = [], prices = 0;
        basket.forEach(product => {
            ids.push(product.id);
            prices += product.price;
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'google_tag_params': {
                'ecomm_prodid': ids,
                'ecomm_pagetype': 'purchase',
                'ecomm_totalvalue': parseFloat(prices),
            },
        });
    }

    otherPageViewed() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'google_tag_params': {
                'ecomm_pagetype': 'other'
            }
        });
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/google-remarketing-tag.js